<template lang="html">
    <section class="summaryOrderWindow col-lg-12">
        <div class="summaryOrderWindow-pagination" v-if="getOrdersWindowList.next || getOrdersWindowList.prev">
            <pagination-order-window :paginationNext="getOrdersWindowList.next" :paginationPrev="getOrdersWindowList.prev"></pagination-order-window>
        </div>
        <title-order-windows :orderTitle="getOrdersWindowById.name"></title-order-windows>
        <date-order-windows :orderWindowDate="getOrdersWindowById"></date-order-windows>
        <div class="summaryOrderWindow-content row">
            <div class="col-lg-9 col-md-9 col-xs-12 listOrderWindow"><list-details-order :orderWindow="getOrdersWindow"></list-details-order></div>
            <div class="col-lg-3 col-md-3 col-xs-12 detailOrderWindow">
                <orderSideBloc :title="$t('orders.orderWindow.titleOrderWindowInformation')">
                    <order-window-information :orderWindowDate="getOrdersWindowById"></order-window-information>
                </orderSideBloc>
                <orderSideBloc :title="$t('orders.orderWindow.titleOrderWindowUpcoming')">
                    <upcoming-order-windows :listOrderWindowUpcoming="getOrdersWindowList.list"></upcoming-order-windows>
                </orderSideBloc>
            </div>
        </div>
    </section>
</template>

<script lang="js">
  import {mapActions, mapGetters} from 'vuex'
  import OrderWindowInformation from "./summary-common/orderWindowInformation";
  import UpcomingOrderWindows from "./summary-common/upcomingOrderWindows";
  import ListDetailsOrder from "./summary-common/listDetailsOrder";
  import OrderSideBloc from "./order-side-bloc";
  import TitleOrderWindows from "./summary-common/titleOrderWindows";
  import DateOrderWindows from "./summary-common/dateOrderWindows";
  import PaginationOrderWindow from "./summary-common/paginationOrderWindow";
  export default  {
    name: 'summary-order-window',
      components: {
          PaginationOrderWindow,
          DateOrderWindows,
          TitleOrderWindows, OrderSideBloc, ListDetailsOrder, UpcomingOrderWindows, OrderWindowInformation},
    data() {
      return {
          dataOrderWindow: {}
      }
    },
    methods: {
        ...mapActions({
            listOrdersWindowAction: "orderWindowList/listOrdersWindowAction",
            ordersWindowAction: "orderWindowList/ordersWindowAction",
            countDownByIdAction: "orderWindowList/countDownByIdAction"
        }),
        async getDataOrderWindow () {
            try {
                await this.countDownByIdAction(this.$route.params.id);
            }
            catch (e) {
                this.funcCatch (e)
            }
        },
        funcCatch (e) {
            if (e.code == 404) {
                this.$router.push({name: "error404"})
            } else {
                this.$swal({
                    text: e.message,
                    type: "error",
                    confirmButtonText: "OK",
                    confirmButtonColor: "grey",
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
            }
        },
        async  functionGetListOrderWindow () {
            try {
                await this.listOrdersWindowAction(this.$route.params.id);
            }
            catch (e) {
                this.funcCatch (e)
            }
        },
        async  functionGetOrderWindow () {
            try {
                await this.ordersWindowAction(this.$route.params.id);
            }
            catch (e) {
                this.funcCatch (e)
            }
        }
    },
    computed: {
        ...mapGetters({
            getOrdersWindowList: "orderWindowList/getOrdersWindowList",
            getOrdersWindow: "orderWindowList/getOrdersWindow",
            getOrdersWindowById: 'orderWindowList/getOrdersWindowById',
        })
    },
    created() {
        this.functionGetListOrderWindow (),
        this.functionGetOrderWindow (),
        this.getDataOrderWindow ()
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";
.summaryOrderWindow {
    @extend %second-text;
    &-content {
        margin-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// SummaryOrderWindow.vue?bd6c50ce